// The `getField()` and `updateField()`
// helper functions, are needed to update
// the mapped fields in a Vuex conform manner.
import { getField } from 'vuex-map-fields'

// Models are used to prepare
// store data to be sent to an API.
import { Status } from '@/store/models/status'

// Initial state
// state object.
// each Vuex instance is just a single state tree.
const state = Status

// getters
const getters = {
  getField
}

// actions
const actions = {
}

// mutations
// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  UPDATE_REQUEST_STATUS (state, payload) {
    state.status = payload.status
    state.statusCode = payload.statusCode
    state.message = payload.message
    state.type = payload.type
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
